// eslint-disable-next-line strict,lines-around-directive
'use strict';

module.exports = require('./lib/provider');
